var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-select',{attrs:{"options":_vm.selectorOptions},nativeOn:{"change":function($event){return _vm.change()}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }